import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable, of } from 'rxjs';
import { CompanyOfferState, CompanyOfferStore } from './company-offer.store';
import { CompanyOfferModel } from './models/company-offer.model';

@Injectable({ providedIn: 'root' })
export class CompanyOfferQuery extends QueryEntity<CompanyOfferState> {
  constructor(protected store: CompanyOfferStore) {
    super(store);
  }

  /**
   * select all available offers
   */
  selectAllOffers(): Observable<CompanyOfferModel[]> {
    return this.selectAll();
  }

  /**
   * Selects all other offers from the same company
   * @param offerId - offerId to return related offers for
   */
  selectRelatedOffers(offerId: number): Observable<CompanyOfferModel[] | undefined> {
    let offer = this.getEntity(offerId);
    if (!offer) {
      return of(offer);
    }

    const foundOffer = offer;
    return this.selectAll({
      filterBy: (relatedOffer) => relatedOffer.CompanyId == foundOffer.CompanyId && relatedOffer.OfferId !== foundOffer.OfferId,
    });
  }

  /**
   * Selects all offers from different companies
   * @param companyId Company to exclude
   */
  selectOtherOffers(companyId: number): Observable<CompanyOfferModel[]> {
    return this.selectAll({ filterBy: (offer) => offer.CompanyId !== companyId });
  }

  /**
   * select a given offer using its offerId
   * @param offerId - Offer to retreive
   */
  selectOffer(offerId: number): Observable<CompanyOfferModel | undefined> {
    return this.selectEntity(offerId);
  }

  /**
   * select all offers for a given company
   * @param companyId - Company to retreive offers for
   */
  selectCompanyOffers(companyId: number): Observable<CompanyOfferModel[]> {
    return this.selectAll({ filterBy: (offer) => offer.CompanyId == companyId });
  }

  /**
   * select all featured offers
   */
  selectFeaturedOffers(): Observable<CompanyOfferModel[]> {
    return this.selectAll({ filterBy: (offer) => offer.Favorite == 1 });
  }
}
